const ixOverlaysState = {
    ixOverlays: undefined,
    requestingIXOverlays: false
};
export default ixOverlaysState;
